import { useMemo } from 'react';
import { machineConnectionStatus } from '../service/status';
import { Tooltip } from 'react-tooltip';
import { useTranslation } from 'react-i18next';
import { MDBIcon } from 'mdb-react-ui-kit';
import { textColor } from 'mdb-react-ui-kit/dist/types/types/colors';
import { OpMachineDTO, OpMachineListItemDTO } from '@scm/common-legacy';

export interface MachineConnectionButtonProps {
    machine: OpMachineDTO | OpMachineListItemDTO;
    size?:
        | 'lg'
        | '1x'
        | '2x'
        | '3x'
        | '4x'
        | '5x'
        | '6x'
        | '7x'
        | '8x'
        | '9x'
        | '10x'
        | '2xs'
        | 'xs'
        | 'sm'
        | 'xl'
        | '2xl';
    tooltipId?: string;
}

export const MachineConnectionButton = ({
    machine,
    size,
}: MachineConnectionButtonProps) => {
    const { t } = useTranslation();
    const { title, color, icon } = useMemo(
        () =>
            machineConnectionStatus(
                machine?.connection &&
                    (!machine.expireAt ||
                        new Date(machine.expireAt).getTime() >
                            new Date().getTime()),
            ),
        [machine],
    );

    return (
        <div>
            <span
                className="me-1"
                title={t(`status:${title}`)}
                // data-tooltip-id={tooltipId || "machine-connection-status"}
                // data-tooltip-content={t(`status:${title}`)}
            >
                <span key={color + icon}>
                    <MDBIcon
                        icon={icon}
                        color={color as textColor}
                        size={size ?? 'lg'}
                    />
                </span>
            </span>
            {/* <Tooltip id={tooltipId || "machine-connection-status"} place="top" style={{zIndex: 9999}}/> */}
        </div>
    );
};
